import { LoaderCircle } from 'lucide-react';
import { FC, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '../utils/class-names.util.ts';

interface Props {
  fitContent?: boolean;
  hideText?: boolean;
}

export const CommonSuspenseFallback: FC<Props> = memo(
  ({ fitContent, hideText }) => {
    const { t } = useTranslation('common');

    const containerClass = useMemo(() => {
      return cn(
        'bg-background relative flex min-h-screen w-full items-center justify-center',
        fitContent && 'min-h-0 w-auto'
      );
    }, [fitContent]);

    return (
      <div className={containerClass}>
        <div className="flex flex-col items-center justify-center gap-2">
          <LoaderCircle className="text-foreground-soft h-12 w-12 animate-spin" />

          {!hideText && <p className="text-foreground-soft text-center text-sm">{t('loading')}</p>}
        </div>
      </div>
    );
  },
  () => true
);
CommonSuspenseFallback.displayName = 'CommonSuspenseFallback';
